import Think from './Think';

export type { ThinkProps } from './Think';

export default Think;
